import React from "react";

function OurCentre() {
  return (
    <div className="container py-5">

      <h2 className="text-center mb-5">Our Study Centres</h2>

      <div className="row">

        {/* CENTRE 1 */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow border-0 h-100">
            <h5>Bankura Centre</h5>
            <p>📍 Bankura, West Bengal</p>
            <p>📞 +91 9876543210</p>
          </div>
        </div>

        {/* CENTRE 2 */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow border-0 h-100">
            <h5>Kolkata Centre</h5>
            <p>📍 Kolkata, West Bengal</p>
            <p>📞 +91 9123456780</p>
          </div>
        </div>

        {/* CENTRE 3 */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow border-0 h-100">
            <h5>Durgapur Centre</h5>
            <p>📍 Durgapur, West Bengal</p>
            <p>📞 +91 9988776655</p>
          </div>
        </div>

      </div>

    </div>
  );
}

export default OurCentre;